/*eslint-disable*/
import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Navbar from "./Componenets/Navbar";
import Footer from "./Componenets/Footer";
import ScrollToTop from "./Componenets/ScrollToTop";
import FicaCalculator from "./Pages/FicaCalculator";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermAndCondition from "./Pages/TermandCondition";
import "./Assests/stylesheet/style.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* Routes */}
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Fica-Calculator" element={<FicaCalculator />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermAndCondition />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
